// extracted by mini-css-extract-plugin
export var sliderRange = "_nc-2";
export var sliderRoot = "_nc-0";
export var sliderThumb = "_nc-3";
export var sliderTrack = "_nc-1";